import React, { useState, useEffect } from "react";

// ✅ Image imports
import cxRole1 from "../../assets/img/cx-roles-09-1.webp";
import cxRole2 from "../../assets/img/cx-roles-09-2.webp";
import virtualization1 from "../../assets/img/data-virtualization-1.webp";
import virtualization3 from "../../assets/img/data-virtualization-3.webp";

const slides = [
  {
    title: "Role-Based Access Control",
    description:
      "Assign custom roles to your team and control who sees what – from orders to payouts – ensuring secure, scalable operations.",
    bgColor: "bg-primary-600",
    elements: [
      {
        type: "image",
        src: cxRole1,
        className:
          "w-[65%] max-w-[500px] h-[60%] top-30px] left-[38%] rounded-[20px]",
      },
      {
        type: "image",
        src: cxRole2,
        className:
          "w-[35%] max-w-[300px] h-auto top-[350px] right-[35%] rounded-[20px] z-10",
      },
      {
        type: "ellipse",
        className:
          "w-[300px] h-[150px] top-[800px] left-[90%] bg-primary-500 opacity-40 rounded-[100px]",
      },
      {
        type: "ellipse",
        className:
          "w-[100px] h-[350px] top-[80px] right-[90%] bg-primary-500 opacity-40 rounded-r-[800px]",
      },
    ],
  },
  {
    title: "Smart Merchant Management",
    description:
      "Streamline merchant activities, boost productivity, and gain real-time visibility into your team's operations.",
    bgColor: "bg-primary-600",
    elements: [
      {
        type: "image",
        src: virtualization3,
        className:
          "w-[1000px] max-w-[400px] h-[630px] top-[180px] left-[41.4%] rounded-[20px] -rotate-[10deg]",
      },
      {
        type: "image",
        src: virtualization1,
        className:
          "w-[1000px] max-w-[700px] h-[500px] top-[80px] right-[17%] rounded-[20px] z-10",
      },
      {
        type: "ellipse",
        className:
          "w-[150px] h-[150px] top-[800px] left-[90%] bg-primary-500 opacity-40 rounded-full",
      },
      {
        type: "ellipse",
        className:
          "w-[200px] h-[250px] top-[0px] left-[90%] bg-primary-500 opacity-40 rounded-full",
      },
    ],
  },
  {
    title: "Secure Payout Handling",
    description:
      "Ensure reliable, automated payouts with secure permissions and audit tracking.",
    bgColor: "bg-primary-600",
    elements: [
      {
        type: "image",
        src: virtualization3,
        className:
          "w-[1000px] max-w-[400px] h-[630px] top-[180px] left-[41.4%] rounded-[20px] -rotate-[10deg]",
      },
      {
        type: "image",
        src: virtualization1,
        className:
          "w-[1000px] max-w-[700px] h-[500px] top-[80px] right-[17%] rounded-[20px] z-10",
      },
      {
        type: "ellipse",
        className:
          "w-[150px] h-[150px] top-[800px] left-[90%] bg-primary-500 opacity-40 rounded-full",
      },
      {
        type: "ellipse",
        className:
          "w-[200px] h-[250px] top-[0px] left-[90%] bg-primary-500 opacity-40 rounded-full",
      },
    ],
  },
];

function AuthCarousel() {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div
      className={`relative w-full h-screen overflow-hidden ${slides[currentSlide].bgColor} text-white-50`}
    >
      {/* Background elements */}
      {slides[currentSlide].elements.map((el, idx) =>
        el.type === "image" ? (
          <img
            key={idx}
            src={el.src}
            alt=""
            className={`absolute object-contain ${el.className}`}
            style={{ maxWidth: "100%", maxHeight: "100%" }}
          />
        ) : (
          <div key={idx} className={`absolute ${el.className}`} />
        )
      )}

      {/* Slide Content */}
      <div className="absolute bottom-16 w-full flex justify-center z-10">
        <div className="flex flex-col max-w-xl px-4 text-center items-center justify-center font-montserrat">
          <h2 className="text-base sm:text-lg md:text-xl font-bold mb-2">
            {slides[currentSlide].title}
          </h2>
          <p className="text-xs sm:text-sm md:text-base">
            {slides[currentSlide].description}
          </p>
        </div>
      </div>

      {/* Slide Indicators */}
      <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2 z-10">
        {slides.map((_, idx) => (
          <span
            key={idx}
            className={`w-2 h-2 rounded-full transition-all duration-300 ${
              idx === currentSlide ? "bg-white-50" : "bg-white-900 opacity-20"
            }`}
          />
        ))}
      </div>
    </div>
  );
}

export default AuthCarousel;
